<template>
  <div class="default-pdf-viewer">
    <iframe
      v-if="isMobile"
      height="100%"
      width="100%"
      :src="`/files/pdfjs-4.0.189-dist/web/viewer.html?file=${url}`"
    ></iframe>
    <iframe v-else height="100%" width="100%" :src="url"></iframe>
  </div>
</template>

<script>
export default {
  computed: {
    url() {
      return this.$route.query.url;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.default-pdf-viewer {
  top: 48px;
  left: 0;
  position: absolute;
  width: 100%;
  height: calc(100% - 55px);
}
</style>
